<script setup lang="ts">
/***
 * template to show object fields as key-value pairs in two columns
 */
const _props = defineProps<DataTableCellProps>();
import { useI18n } from 'vue-i18n';

import type { DataTableCellProps } from './templateTypes';
const { t } = useI18n();
</script>

<template>
  <div v-if="cell.value" class="space-y-1">
    <div v-for="(val, key) in cell.value" :key="key" class="flex gap-2">
      <div class="font-semibold w-32 truncate">{{ t(`labels.${key}`) }}</div>
      <div class="flex-1">{{ val }}</div>
    </div>
  </div>
  <div v-else>-</div>
</template>
